import React from 'react';
import PropTypes from 'prop-types';
import './LoginPanel.scss';
import { Link } from 'react-router-dom';
import AuthModal from 'desktop/components/AuthModal/AuthModalLoadable';

const LoginPanel = props => {
    const { dataLocale, section, loginStatus, userInfo, loginLoader, openLoginTab, openSignUpTab, registerActions, commonCallsActionCreators, cartActions } = props;
    const { MY_ORDERS, MY_PRESCRIPTION, MY_STORE_CREDIT, MY_DITTOS, ACCOUNT_INFORMATION, SIGN_IN, SIGN_UP, SPECSY, LOGOUT } = dataLocale || {};
    return (
        <div className="">
            <div onClick={() => { if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.header.click.headerClick(section, 'LOGIN', loginStatus); }}>
                {loginLoader ? <p className="saving"><span>.</span><span>.</span><span>.</span></p> :
                    <div>
                        {
                            loginStatus && userInfo !== null ?
                                <div className="login-panel">
                                    {userInfo.result.firstName ? <div>{userInfo.result.firstName}<i className="fa fa-caret-down"></i></div> : <span>{SPECSY}</span>}
                                    <div>

                                        <div className="navbar-dropdown-menu">
                                            {loginStatus === true
                                                ? <div>
                                                    <Link to="/customer/account/" className="dropdown-list">{MY_ORDERS}</Link>
                                                    <Link to="/customer/prescriptions/" className="dropdown-list">{MY_PRESCRIPTION}</Link>
                                                    <Link to="/customer/account/storecredit/" className="dropdown-list">{MY_STORE_CREDIT}</Link>
                                                    <Link to="/customer/ditto-profile/" className="dropdown-list">{MY_DITTOS}</Link>
                                                    <Link to="/customer/account/edit/" className="dropdown-list">{ACCOUNT_INFORMATION}</Link>
                                                    <a
                                                        className="dropdown-list"
                                                        onClick={() => {
                                                            registerActions.logoutUser();
                                                            commonCallsActionCreators.logoutUser();
                                                            cartActions.logoutUser();
                                                            sessionStorage.removeItem('orderActivePage');
                                                            document.location.href = '/';
                                                            window?.Freshbots?.resetCustomer(true);
                                                        }}
                                                    >{LOGOUT}</a>
                                                </div> : ''}

                                        </div>
                                    </div>
                                </div> :
                                <div className="user-name" onMouseOver={() => { AuthModal.preload(); }} onFocus={() => { AuthModal.preload(); }}>
                                    <span onClick={openLoginTab} className="cursor-pointer">{SIGN_IN} &</span> <span onClick={openSignUpTab} className="cursor-pointer">{SIGN_UP}</span>
                                </div>
                        }
                    </div>
                }
            </div>
        </div>
    );
};

LoginPanel.propTypes = { section: PropTypes.any, loginStatus: PropTypes.bool, userInfo: PropTypes.object, loginLoader: PropTypes.bool, openLoginTab: PropTypes.func, openSignUpTab: PropTypes.func };

export default LoginPanel;
